/*eslint-disable @typescript-eslint/restrict-plus-operands */
import { FC, useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { Button } from "@ht/components";
import CallAnswerIcon from "@ht/shared/fonts/deos-pis/call";
import CallMissedIcon from "@ht/shared/fonts/deos-pis/call-missed";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";

import { IVCallIncomingMessage } from "../../../../app/videocall/types";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { vCallIncomingMessageReceived, vCallSendMessage, vCallStateChanged } from "../../../../app/videocall/videoSlice";
import { setFloatingCoordinate, setOverlay } from "../../../../app/layout/layoutStateSlice";
import { toIsoString, uid } from "@ht/shared/methods";
import { now } from "moment";
import { useDragging } from "../../../../hooks/useDragging";

import { AntmediaContext } from "../../../../App";
import { setOnCall } from "../../../../app/userState/userStateSlice";

import ringtone from "../../../../../public/sound/ringtone.mp3";
import useSound from "use-sound";

interface IProps {
    streamName: string;
    handleStreamName(name: string): void;
    handleChangeRoomStatus(status: string): void;
    meetingStatus: string;
}

const MiniAudioCallControl: FC<IProps> = ({ handleChangeRoomStatus, handleStreamName, meetingStatus }) => {
    const antmedia = useContext(AntmediaContext);
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.auth);
    const { incomingRoom } = useAppSelector((state) => state.chat);
    const { vCallState, vCallIncomingMessage } = useAppSelector((state) => state.vcall);
    const { floatingLocation, overlay } = useAppSelector((state) => state.layoutstate);
    const [play, { stop }] = useSound(ringtone);
    const [callConnected, setCallConnected] = useState(false);
    const [pickedUp, setPickedUp] = useState(false);
    const [ringing, setRinging] = useState(true);
    const [callTime] = useState(Date.now());
    const [callDescription, setCallDescription] = useState(`Incoming video call...`);
    const [callId, setCallId] = useState("")
    const [rejected, setRejected] = useState(false)
    const [busyIntervalId, setBusyIntervalId] = useState(0)
    const callnotifWidth = 260;
    const locationX = floatingLocation.x === 0 ? screen.width - callnotifWidth - floatingLocation.x - 10 : floatingLocation.x
    const locationY = floatingLocation.y === 0 ? floatingLocation.y + 66 : floatingLocation.y
    const { ref, x, y, isDragging, setPos } = useDragging(locationX, locationY, 240, 400);
    const [ready, setReady] = useState(false)

    const notifyDialResult = (dialresult: string) => {

        const payload = {
            requesttype: "DialResult"
            , ActiveCall: {
                CallId: callId
                , CalleeStreamId: "agentStream" + String(user?.deviceId)
                , CallerStreamId: vCallIncomingMessage.deviceid
                , Callee: user?.username
                , Caller: vCallIncomingMessage.username
                , DialResult: dialresult
                , CallTime: toIsoString(new Date(callTime))
                , DisconnectedTime: dialresult === "Ringing" || dialresult === "Answer" ? undefined : toIsoString(new Date())
                , Channel: "video"
                , SubscriptionId: process.env.REACT_APP_SUBSCRIPTIONID
                , SessionId: vCallIncomingMessage.sessionid
                , CallType: vCallIncomingMessage.calltype
            }
        }
        dispatch(vCallSendMessage({
            content:
                JSON.stringify(payload)
        }));
    }
    const resetIncomingCall = () => {
        dispatch(vCallIncomingMessageReceived({} as IVCallIncomingMessage));
    }
    const resetCallState = () => {
        const vcstate = { ...vCallState };
        vcstate.isCalling = false;
        vcstate.connectedTime = 0;
        vcstate.duration = 0;
        vcstate.roomId = ""
        vcstate.username = ""
        vcstate.name = ""
        dispatch(vCallStateChanged(vcstate));
    }
    const Busy = () => {
        stop()
        setRinging(false);
        setPickedUp(false);
        setCallDescription("Missed Call. You were busy.")
        notifyDialResult("Busy");
        dispatch(setOnCall(""));

    }
    const BusyTimer = () => {
        let i = 0;
        let sentRinging = false;
        const tmr = window.setInterval(() => {
            if (callId !== "" && !sentRinging) {
                notifyDialResult("Ringing")
                sentRinging = true
            }
            i++;
            if (i > 8) {
                if (!callConnected && !rejected) {
                    Busy()
                    setCallDescription("Missed Call. You were busy.")
                    handleChangeRoomStatus("missing-audio-dms")
                }
                window.clearInterval(tmr)
            }
        }, 1000);
        setBusyIntervalId(tmr)
    }
    const answerCall = () => {
        stop()
        handleStreamName(user?.username ?? "")
        clearInterval(busyIntervalId)
        setRinging(false);
        setPickedUp(true);
        setCallConnected(true);
        setCallDescription("Answered");
        notifyDialResult("Answer")
        let sessionid = incomingRoom.find(z => z.roomId == vCallIncomingMessage.roomId)?.sessionId
        if (sessionid === undefined || sessionid === "")
            sessionid = uid(36)
        const vcstate = { ...vCallState };
        vcstate.isCalling = true;
        vcstate.connectedTime = now()
        vcstate.CallId = callId
        vcstate.SessionId = String(sessionid)
        vcstate.roomId = vCallIncomingMessage.roomId
        vcstate.username = vCallIncomingMessage.username
        vcstate.name = vCallIncomingMessage.username
        dispatch(vCallStateChanged(vcstate));
        setPos({
            x: x - 260,
            y: y,
        })

        handleChangeRoomStatus("meeting-audio-dms");
    }
    const rejectCall = () => {
        antmedia.turnOffLocalCamera("localVideo");
        stop()
        setRejected(true)
        notifyDialResult("Reject")
        handleChangeRoomStatus("close")
        resetIncomingCall();
    }
    const closeModal = () => {
        antmedia.turnOffLocalCamera("localVideo");
        handleChangeRoomStatus("close");
        resetIncomingCall();
        resetCallState();
    }
    useEffect(() => {
        if (meetingStatus === "waiting-audio-dms") {
            setPickedUp(false)
            setRinging(true);
            BusyTimer()
            setCallDescription("Incoming audio call...")
        }

    }, [meetingStatus])



    const callButton = (
        <div className="flex flex-row justify-center h-[68px] w-[100%] justify-center gap-[36px]">
            {/* <div className="flex flex-col items-center gap-[6px]">
                <Button shape="ellipse" onClick={() => rejectCall()} type="button" variant="contained" color="danger" iconButton className="w-[44px] h-[44px]">
                    <CallAnswerIcon className="w-6 h-6 text-white rotate-[135deg]" />
                </Button>
                <span className="text-black text-base font-semibold">Reject</span>

            </div> */}
            <div className="flex flex-col items-center gap-[8px]">
                <Button shape="ellipse" onClick={() => answerCall()} type="button" variant="contained" color="primary" iconButton className="w-[44px] h-[44px]">
                    <CallAnswerIcon className="w-6 h-6 text-white" />

                </Button>
                <span className="text-black text-base font-semibold">Accept</span>
            </div>
        </div>
    )

    const initVideo = () => {
        antmedia.initialize({ audioOnly: true });
        setTimeout(() => {
            if (antmedia.mediaManager.localStream === null) {
                alert("mic nya di allow")
                return;
            }
            antmedia.mediaManager.localVideo = document.getElementById("localVideo");
            if (antmedia.mediaManager.localVideo)
                (antmedia.mediaManager.localVideo as HTMLVideoElement).srcObject = antmedia.mediaManager.localStream;
        }, 2000);
    }
    useEffect(() => {
        setCallId(uid(21))

        play()
        initVideo()
        setReady(true)
        return () => {
            stop()
        }
    }, [])
    useEffect(() => {
        if (ready)
            if (!isDragging)
                dispatch(setFloatingCoordinate({ x, y }));
    }, [isDragging])




    return (
        <>
            <div onClick={() => dispatch(setOverlay(false))} onKeyDown={() => { }} role="none" className={clsx("fixed z-[19] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                !overlay && "hidden"
            )}>
            </div>
            <div

                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    isDragging && "bg-geyser",
                    !isDragging && "bg-white",
                    "w-[234px] h-[358px] absolute shadow-sm rounded-lg bg-white z-[21] p-[8px] absolute overflow-hidden"
                )}>

                <div className="flex flex-col justify-between items-center overflow-hidden h-[100%] w-[100%]">
                    <div ref={ref} className="draggable flex flex-col h-[100%] w-[100%]">
                        <div className="draggable flex flex-col w-[100%] items-center gap-[0px]">
                            <div className="flex flex-row justify-between w-[100%] ">
                                <div className="text-md text-white self-end z-[1000] p-[2px] rounded-lg text-black"></div>

                                <div role="button" tabIndex={-1} onKeyDown={ringing ? rejectCall : closeModal}
                                    onClick={ringing ? rejectCall : closeModal} className="text-md text-black self-end"><CloseIcon className="w-[16px] h-[16px]" width={24} height={24} />
                                </div>

                            </div>

                            <div className="draggable flex flex-col py-[14px] gap-[32px] items-center">
                                <div className="flex flex-col items-center justify-between gap-[6px]">
                                    <div className="text-base font-semibold leading-4 text-gray-400">Audio Call</div>
                                    <div className="text-lg font-semibold leading-7 text-black">{vCallIncomingMessage.username.length > 20 ? vCallIncomingMessage.username.substring(0, 17) + "..." : vCallIncomingMessage.username}</div>
                                    <div className="text-base font-semibold leading-4 text-gray-400">{callDescription}</div>
                                </div>
                                <div className="w-[89px] h-[89px] rounded-full bg-geyser"></div>
                                <div className="h-[68px]">
                                    {(ringing || pickedUp) && callButton}
                                    {(!ringing && !pickedUp) &&
                                        // callButton
                                        (
                                            <div className="flex flex-col items-center h-[68px] w-[89px] w-[100%] center">
                                                <Button shape="ellipse" onClick={() => { }} type="button" variant="contained" color="danger" iconButton className="w-[44px] h-[44px]">
                                                    <CallMissedIcon className="w-[22px] h-[22px] mt-[2px] -ml-[2px] text-white" />
                                                </Button>
                                            </div>
                                        )
                                    }
                                </div>




                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    );
};

export default MiniAudioCallControl;
